// ================================================= /
// ======   Hover Timer JS   ======================= /
// ================================================= /

/** Dependencies -------------------------------------------- */

// Design system

import { getCssVar } from '../helpers'

/** The beef ------------------------------------------------ */

/**
 * Class for the hover timer functionality.
 * Adds a class to an element when it is hovered and removes it after a timer.
 */
export default class HoverTimer {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '[data-hover-timer]';
		this.hoveredClass = 'was-hovered';
		this.eventNamespace = 'Hyper15HoverTimer';
		this.propertyName = 'hoverTimer';
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		const elements = document.querySelectorAll( this.selector )

		if ( elements.length ) {
			Array.from( elements ).map( ( element ) => element.addEventListener( 'mouseenter', this.handleMouseEnter.bind( this ) ) )
		}
	}

	/**
	 * Handles the mouse enter.
	 * Adds the hovered class.
	 */
	handleMouseEnter( event ) {

		const element = event.currentTarget
		const elementTimer = getCssVar( this.propertyName, element )

		element.classList.add( this.hoveredClass )

		window.setTimeout(
			function() {
				element.classList.remove( this.hoveredClass );
			}.bind( this ),
			parseInt( elementTimer || 1, 10 ) * 1000
		);
	}

}
